import type { TFunction } from "i18next"
import { z } from "zod"

export const formSchemaSignIn = (t: TFunction) =>
  z.object({
    email: z
      .string()
      .email({ message: t("validation.invalidEmail") })
      .min(1, t("validation.required")),
    password: z
      .string()
      .min(
        6,
        t("validation.passwordMinLength", { count: 6 })
      ),
  })
export type FormSchemaSignIn = z.infer<
  ReturnType<typeof formSchemaSignIn>
>
